import { render } from "./staticMenu.vue?vue&type=template&id=5a2ef20c&scoped=true"
import script from "./staticMenu.vue?vue&type=script&lang=js"
export * from "./staticMenu.vue?vue&type=script&lang=js"

import "./staticMenu.vue?vue&type=style&index=0&id=5a2ef20c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2ef20c"]])

export default __exports__